import { ARCHIVE_RUBRICS } from '~/pages/archive/data';
export const DROPDOWN_RUBRICS_ITEMS = [
    // {
    //   title: 'Все рубрики',
    //   value: '/archive/rubrics',
    // },
    ...ARCHIVE_RUBRICS.map(({ title, to }) => {
        return {
            title,
            value: to,
        };
    }),
];
